import React from 'react'
import MyEditor from './TinyMCEEditor'
import {
  getContent,
  isContentChanged,
  resetIsContentChanged,
  isUndoEmpty,
  isRedoEmpty,
  handleRedo,
  handleUndo,
} from './TinyMCEEditor'

import { EditorContainer, EditorHolder } from './styles'

const TextEditor = (props) => {
  return (
    <>
      <EditorHolder>
        <EditorContainer
          id="chapterBody"
          translate="no"
          isBonusActive={props.isFirstChapterPublishBonus}
        >
          <MyEditor {...props} />
        </EditorContainer>
      </EditorHolder>
      {/* <Spacer/> */}
    </>
  )
}

export {
  TextEditor,
  getContent,
  isContentChanged,
  resetIsContentChanged,
  isUndoEmpty,
  isRedoEmpty,
  handleRedo,
  handleUndo,
}
